import { useState } from "react";
import { ConfirmDialog } from "../components/ConfirmDialog";
import { riskStage } from "./riskStage";

/**
 * Asked when Settings closes, or another group or account opens, while Risk limits hold staged
 * edits. Cancel (the focused default) keeps the edits so they can still be saved, and puts focus
 * back where it was (so Escape still reaches the Settings dialog).
 */
export function DiscardRiskChanges({
  onCancel,
  onDiscard,
}: {
  onCancel: () => void;
  onDiscard: () => void;
}): React.JSX.Element {
  const parts = riskStage.dirtyLabels;
  const [opener] = useState(() => document.activeElement);
  return (
    <ConfirmDialog
      title="Discard unsaved risk changes?"
      confirmLabel="Discard changes"
      onCancel={() => {
        onCancel();
        if (opener instanceof HTMLElement && opener.isConnected) opener.focus();
      }}
      onConfirm={onDiscard}
    >
      <p>
        {parts.length > 0 ? `${parts.join(", ")}: ` : ""}your edits are not saved, and the saved values stay
        in force. Cancel, then press Save risk limits to keep the edits.
      </p>
    </ConfirmDialog>
  );
}
